import { render, staticRenderFns } from "./reviewDialog.vue?vue&type=template&id=cd88b7fc&scoped=true&"
import script from "./reviewDialog.vue?vue&type=script&lang=js&"
export * from "./reviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./reviewDialog.vue?vue&type=style&index=0&id=cd88b7fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd88b7fc",
  null
  
)

export default component.exports